import { useEffect } from 'react';

import { eventEmitter } from '../event-emitter';
import type { EventName, Subscriber } from '../event-emitter/types';

export function useEventListener<T extends EventName>(
	eventName: T,
	subscriber: Subscriber<T>,
): void {
	useEffect(() => {
		return eventEmitter.on(eventName, subscriber);
	}, [eventName, subscriber]);
}
